import React from 'react'
import { Button, Grid, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import BackgroundContainer from '../components/BackgroundContainer';
import BaseFormContainer from '../components/BaseFormContainer';
import BaseButton from '../components/BaseButton';


const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.05rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});


const NotFoundPage = () => {
    const navigate = useNavigate();
  return (
    <BackgroundContainer>
      <BaseFormContainer>
        <Subtitle sx={{fontSize:'1.3rem', marginBottom: '10px'}} >
            Seems like you got lost.. There is nothing to see here..
            </Subtitle>
        <BaseButton onClick={() => navigate("/")} >Return To Homepage..</BaseButton>
      </BaseFormContainer>
    </BackgroundContainer>
  )
}

export default NotFoundPage